import UtmTracker from './tracking-utm';
import AklamioTracker from "./tracking-aklamio";

document.addEventListener('DOMContentLoaded', _ => {

	const solarLeadFormCompact = document.querySelector('.js-solar-lead-form[data-solar-lead-form-variant="compact"]'),
		UTMTracking = new UtmTracker(),
		UTMParams = UTMTracking.getStoredUTMParams(),
		AklamioTracking = new AklamioTracker(),
		AklamioParams = AklamioTracking.getStoredAklamioParams();

	if (solarLeadFormCompact) {
		AklamioTracking.updateStoredAklamioParams();
	}

	document.querySelectorAll('form:not(.js-no-utm)').forEach(form => {
		for (const property in UTMParams) {
			const hiddenUtm = form.querySelector('input[type=hidden][name$="[' + property + ']"]');
			if (hiddenUtm) {
				hiddenUtm.value = UTMParams[property];
			}
		}

		for (const property in AklamioParams) {
			const hiddenAklamio = form.querySelector('input[type=hidden][name$="[' + property + ']"]');
			if (hiddenAklamio) {
				hiddenAklamio.value = AklamioParams[property];
			}
		}
	})
}, {passive: true, once: true});
